import { makePssError } from "./makePssError";

export { makePssError };

export const ResolveTemplateError = makePssError("ResolveTemplateError");
export const ParseValueError = makePssError("ParseValueError");
export const PortalNoContentError = makePssError("PortalNoContentError");
export const PortalDoubleMountedError = makePssError(
  "PortalDoubleMountedError"
);
